import { useState, useCallback } from 'react';
import { authApi } from '@/sdk/shared';
import type { ResetPasswordRequest, ResetPasswordResponse, ApiError } from '../types';

interface UseResetPasswordReturn {
  resetPassword: (data: ResetPasswordRequest) => Promise<ResetPasswordResponse>;
  isLoading: boolean;
  error: ApiError | null;
  clearError: () => void;
}

export const useResetPassword = (): UseResetPasswordReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);

  const resetPassword = useCallback(async (data: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await authApi.resetPassword(data);
      return response;
    } catch (err) {
      const error = err as ApiError;
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    resetPassword,
    isLoading,
    error,
    clearError,
  };
};
